import { memo } from "react";
import { Box, Link, Typography } from "@mui/material";

const Footer = memo(({ sx = {} }) => {

    return (
        <Box
            sx={{
                height: "55px", display: "flex",
                flexDirection: "column", gap: "2px",
                justifyContent: "center",
                ...sx
            }}
        >
            <Typography variant="caption" color={"rgb(0, 0, 0)"} fontWeight={900}>
                ©️ 2026 <Link href="https://www.akademie-bildung-entwicklung.de" target="_blank">akademie-bildung-entwicklung.de</Link> . All Rights Reserved. | <Link href="https://www.akademie-bildung-entwicklung.de/datenschutz" target="_blank">Datenschutz</Link> | <Link href="https://www.akademie-bildung-entwicklung.de/impressum" target="_blank">Impressum</Link>
            </Typography>
        </Box>
    );
});

export default Footer;